import 'bootstrap';
import 'jquery';
import 'metisMenu';
import LocaleManager from '@francelink/oswedev/dist/shared/tools/LocaleManager';
import DAOStore from '@francelink/oswedev/dist/vuejsclient/ts/components/dao/store/DaoStore';
import OnPageTranslationStore from '@francelink/oswedev/dist/vuejsclient/ts/components/OnPageTranslation/store/OnPageTranslationStore';
import AppVuexStoreManager from '@francelink/oswedev/dist/vuejsclient/ts/store/AppVuexStoreManager';
import VueAppBase from '@francelink/oswedev/dist/vuejsclient/VueAppBase';
import 'select2';
import LoginAppController from './LoginAppController';
import InitializeLoginModulesDatas from './ts/generated/InitializeLoginModulesDatas';
import LoginVueMain from '@francelink/oswedev/dist/vuejsclient/login/main/LoginVueMain';
import MYMALERBALoginVueModule from './views/modules/mymalerba/MYMALERBALogInVueModule';
import AlertStore from '@francelink/oswedev/dist/vuejsclient/ts/components/alert/AlertStore';
import './scss/login-skin.scss';
import PWAController from '@francelink/oswedev/dist/vuejsclient/public/pwa/PWAController';
import MyMalerbaPWAController from '../vuejsclient/public/pwa/MyMalerbaPWAController';
// import "https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js";
import "../client/public/js/login-script.js";


export default class LoginApp extends VueAppBase {
    public static getInstance(): LoginApp {
        if (!LoginApp.instance) {
            LoginApp.instance = new LoginApp();
        }
        return LoginApp.instance;
    }

    private static instance: LoginApp;

    protected constructor() {
        super(LoginAppController.getInstance(), InitializeLoginModulesDatas);
    }

    public createVueMain() {

        AppVuexStoreManager.getInstance().registerModule(DAOStore.getInstance());
        AppVuexStoreManager.getInstance().registerModule(OnPageTranslationStore.getInstance());

        AppVuexStoreManager.getInstance().registerModule(AlertStore.getInstance());

        AppVuexStoreManager.getInstance().configure_store();

        return new LoginVueMain({
            router: this.vueRouter,
            store: AppVuexStoreManager.getInstance().appVuexStore,
            i18n: LocaleManager.getInstance().i18n
        } as any);
    }

    protected async initializeVueAppModulesDatas() {
        // AccessPolicyLoginVueModule.getInstance();

        MYMALERBALoginVueModule.getInstance();

        PWAController.getInstance().custom_initialize_pwa = MyMalerbaPWAController.getInstance().initialize_pwa.bind(MyMalerbaPWAController.getInstance());
    }
}

LoginApp.getInstance().runApp();

// await ThreadHandler.sleep(100);

// (function ($) {
//     jQuery(function () {
//         // element argument can be a selector string
//         //   for an individual element
//         $(".main-carousel").flickity({
//             // options
//             cellAlign: "left",
//             draggable: false,
//             contain: true,
//             prevNextButtons: false,
//             pageDots: false,
//             autoPlay: 7000,
//             selectedAttraction: 0.015,
//             wrapAround: true,
//             //   friction: 0.15,
//         });
//     });
// })(jQuery);
